var riot = require('riot');
riot.tag('editor', '<textarea name="source" onkeyup="{ adjust }" onchange="{ change }">{ opts.source }</textarea>', 'editor , [riot-tag="editor"] { display: block; font-family: monospace; border: 1px solid #ccc; border-radius: .5em; margin: 1em; } editor textarea , [riot-tag="editor"] textarea { width: 100%; padding: 1em; border: none; margin: 0; border-radius: .5em; box-sizing: border-box; }', function(opts) {
    this.change = function(e) {
      this.trigger('change', this.source.value)
    }.bind(this);
    this.adjust = function() {
      var ta = this.source
      if (ta.scrollHeight > ta.clientHeight)
        ta.style.height = ta.scrollHeight + "px"
    }.bind(this);
    this.on('mount', function() {
      this.adjust()
    })
  
});
